import { CardData, SideBySideData } from '../../types';

export const validateCard = (card: CardData, cardName: string): string | null => {
    if (!card.image) return `${cardName}: Image is required.`;
    if (!card.title.trim()) return `${cardName}: Title is required.`;
    if (!card.btnText.trim()) return `${cardName}: Button text is required.`;
    if (!card.link.trim()) return `${cardName}: Link URL is required.`;
    return null;
};

export const validateSideBySideData = (data: SideBySideData): string | null => {
    const error1 = validateCard(data.card1, 'Left Card');
    if (error1) return error1;

    const error2 = validateCard(data.card2, 'Right Card');
    if (error2) return error2;

    return null;
};
